import Settings16 from '@carbon/icons-react/es/settings/16';
import styled from 'styled-components';
import { BodyShort01 } from 'components/styles';

export const Text = styled.p`
  ${BodyShort01};
  margin-bottom: 0;
`;

export const FooterContainer = styled.div`
  text-align: left;
  display: flex;
  align-items: center;
  gap: var(--spacing-06);
  justify-content: space-between;
`;

export const SettingsIcon = styled(Settings16)`
  margin: 0 var(--spacing-02);
`;

export const LinkText = styled(Text)`
  margin-left: var(--spacing-02);
`;
